// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');

const LoanCollectiveTag = (props) => {
    const productType = {
        type: props.immLoan.get('product'),
        subType: props.immLoan.get('productSubType'),
        standard: props.immLoan.get('productStandard')
    };

    return (
        <CollectiveTag
            extraClass={props.extraClass}
            productType={productType}
            tooltipContent={props.tooltipContent}
        />
    );
}

LoanCollectiveTag.propTypes = {
    extraClass: PropTypes.string,
    immLoan: PropTypes.object.isRequired,
    tooltipContent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ])
};

module.exports = LoanCollectiveTag;
